export default __webpack_public_path__ + "assets/megaphone-default.png";